<template>
  <div class="list-item"  @click="itemClick">
    <div class="order-header">
      <div class="flex-row">
        <div class="img" :class="CardMap[item.originProductName]"></div>
        <span class="orderNo">{{ item.productName }}</span>
      </div>
      <div class="orderStatus" :class="{paid: item.rechargeStatus === CarLifeOrderStatus.success}">{{ item.rechargeStatusName }}</div>
    </div>
    <div class="content">
      <div class="content-flex">
        <div class="left">订单编号</div>
        {{ item.orderNo }}
      </div>
      <div class="content-flex">
        <span class="left">支付时间</span>
        {{ item.paidTime }}
      </div>
      <div class="content-flex">
        <span class="left">购买数量</span>
        {{ item.cardQuantity }}张
      </div>
      <div class="content-flex">
        <span class="left">支付金额</span>
        ¥ {{ item.paidPrice || 0 }}元
      </div>
    </div>
  </div>
</template>

<script >
import { CarLifeOrderStatus, CardMap } from "@/common/constant";

export default {
  name: 'record-item',
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      CarLifeOrderStatus,
      CardMap,
    }
  },
  methods: {
    itemClick() {
      this.$router.push({
        path: '/mediaOrderDetail',
        query: {
          orderNo: this.item.orderNo
        }
      })
    },
  }
}

</script>

<style lang="scss" scoped>
@import "../../../assets/card-icon.scss";
.list-item {
  background: white;
  margin-top: 12px;

  .order-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    box-shadow: inset 0px -1px 0px 0px rgba(230,230,230,1);
    padding: 0 20px;
    
    .flex-row {
      word-break: break-all;
      height: 60px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .img {
        width: 32px;
        height: 32px;
        background-size: 32px 32px;
      }
      .orderNo {
        font-family: PingFangSC-Medium;
        font-weight: bold;
        padding-left: 8px;
      }
    }
    .orderStatus {
      min-width: 0.75rem;
      text-align: right;

      &.paid {
        color: #3399FF;
      }
    }
  }
  .content {
    padding: 0 20px 20px;
    .content-flex {
      width: 100%;
      display: flex;
      flex-direction: row;
      word-break: break-all;
      margin-top: 20px;
      color: #383838;
      .left {
        color: #787878;
        min-width: 1.62rem;
      }
    }
  }
}


</style>